import apiService from "apiService";
import React, { useEffect, useRef, useState } from "react";
import { setAgeFromVisit } from "view/component/helper/helper";
import TableILPDewasa from "view/component/TableILPDewasa";
import FormScreening from "./FormScreening";
import { formatDateIndo } from "helper/helper";
import ReactToPrint from "react-to-print";
import { TableILPDewasaPrint } from "view/component/TableILPDewasaPrint";

const Ilp = (props) => {
  const printTabel = useRef();
  const patient_id = props.detilPx.patient_id;
  const nik = props.detilPx.patients.nik;
  const visit_id = props.detilPx.id;
  const clinic_id = props.detilPx.clinic_id;
  const is_pregnant = props.detilPx.anamneses[0]
    ? props.detilPx.anamneses[0].pregnant_status == "-"
      ? false
      : true
    : false;
  const sex = props.detilPx.patients.sex == 1 ? "L" : "P";

  const [selected_form, setselected_form] = useState(0);
  const [kluster, setkluster] = useState();
  const [hamil, sethamil] = useState(false);

  const [kategori, setkategori] = useState();

  useEffect(() => {
    printTabel.current?.focus();
    console.log(printTabel);
  }, []);

  const getAge = () => {
    let age = setAgeFromVisit(
      props.detilPx.patients.birth_date,
      props.detilPx.created_at
    );
    let tahun = age.y;
    if (tahun <= 4) {
      tahun = parseFloat(age.y) + parseFloat(age.m / 12);
    }
    return tahun;
  };
  let umur = getAge();
  const [ref_screening, setref_screening] = useState([]);
  const getScreening = async () => {
    let result = await apiService.get(
      `/ilp/screening_patient/history_by_screening_id?patient_id=${nik}`
    );
    if (result.code == 200) {
      let dt = result.data;
      let kelompok_umur = [];
      let res = await apiService.get(
        `/ilp/ref_screening_by_clinic?clinic_id=${clinic_id}&age=${umur}&is_pregnant=${is_pregnant}&sex=${sex}`
      );
      if (res.code == 200) {
        sethamil(is_pregnant);
        if (dt.length > 0 || dt.length == undefined) {
          Object.keys(dt).forEach(function (key, index) {
            if (res.data.find((a) => a.cluster == 3)) {
              // console.log("Ora meteng");
              kelompok_umur[key] = generate_by_date_cluster_3(dt[key]);
              setkluster(3);
            } else {
              setkluster(2);
              if (is_pregnant) {
                // console.log("pregnant 1");
                kelompok_umur[key] = generate_by_date_cluster_2_hamil(dt[key]);
              } else {
                console.log(umur);
                if (umur >= 7) {
                  kelompok_umur[key] = generate_by_date_cluster_2_remaja(
                    dt[key]
                  );
                } else {
                  kelompok_umur[key] =
                    generate_by_date_cluster_3_anak_prasekolah(dt[key]);
                }
              }
            }
          });
        } else {
          if (res.data.find((a) => a.cluster == 3)) {
            kelompok_umur = generate_by_date_cluster_3([]);
            setkluster(3);
          } else {
            // console.log("2");
            setkluster(2);
            if (is_pregnant) {
              // console.log("pregnant 2");
              kelompok_umur = generate_by_date_cluster_2_hamil([]);
            } else {
              if (umur >= 7) {
                kelompok_umur = generate_by_date_cluster_2_remaja([]);
              } else {
                kelompok_umur = generate_by_date_cluster_3_anak_prasekolah([]);
              }
            }
          }
        }
        let merge_data = [];
        res.data.map((a) => {
          merge_data.push({
            ...a,
            ...kelompok_umur[a.id],
          });
        });
        // console.log(merge_data);
        setref_screening(merge_data);
      } else {
        setref_screening([]);
      }
    } else {
      setref_screening([]);
    }
  };

  const generate_by_date_cluster_3 = (result_data) => {
    let data_umur = {
      18: [],
      "19_30": [],
      "30_40": [],
      "40_45": [],
      "45_50": [],
      "50_60": [],
      60: [],
    };
    result_data.map((a) => {
      let umur = parseFloat(a.umur);
      if (umur >= 18 && umur < 19) {
        data_umur["18"].push(a);
      } else if (umur >= 19 && umur < 30) {
        data_umur["19_30"].push(a);
      } else if (umur >= 30 && umur < 40) {
        data_umur["30_40"].push(a);
      } else if (umur >= 40 && umur < 45) {
        data_umur["40_45"].push(a);
      } else if (umur >= 45 && umur < 50) {
        data_umur["45_50"].push(a);
      } else if (umur >= 50 && umur < 60) {
        data_umur["50_60"].push(a);
      } else {
        data_umur["60"].push(a);
      }
    });
    return data_umur;
  };

  const generate_by_date_cluster_2_remaja = (result_data) => {
    let data_umur = {
      "7-10": [],
      "10-12": [],
      "12-15": [],
      15: [],
    };
    result_data.map((a) => {
      let umur = parseFloat(a.umur);
      if (umur >= 7 && umur < 10) {
        data_umur["7-10"].push(a);
      } else if (umur >= 10 && umur < 12) {
        data_umur["10-12"].push(a);
      } else if (umur >= 12 && umur < 15) {
        data_umur["12-15"].push(a);
      } else if (umur >= 15 && umur < 18) {
        data_umur["15"].push(a);
      }
    });
    return data_umur;
  };

  const generate_by_date_cluster_2_hamil = (result_data) => {
    let data_umur = {
      K1: [],
      K2: [],
      K3: [],
      K4: [],
      K5: [],
      K6: [],
      Hamil: [],
      "-": [],
      null: [],
    };
    result_data.map((a) => {
      if (a.pregnant_id != null) {
        if (a.pregnant_id !== "") {
          data_umur[a.pregnant_id].push(a);
        }
      }
    });
    return data_umur;
  };

  const generate_by_date_cluster_3_anak_prasekolah = (result_data) => {
    let data_umur = {
      "Baru Lahir": [],
      "1 bulan": [],
      "2 bulan": [],
      "6 bulan": [],
      "9 bulan": [],
      "16 bulan": [],
      "18 bulan": [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
    };
    result_data.map((a) => {
      let umur = parseFloat(a.umur);
      if (umur == 0) {
        data_umur["Baru Lahir"].push(a);
      } else if (umur >= 0 && umur < 2 / 12) {
        data_umur["1 bulan"].push(a);
      } else if (umur >= 2 / 12 && umur < 6 / 12) {
        data_umur["2 bulan"].push(a);
      } else if (umur >= 6 / 12 && umur < 9 / 12) {
        data_umur["6 bulan"].push(a);
      } else if (umur >= 9 / 12 && umur < 16 / 12) {
        data_umur["9 bulan"].push(a);
      } else if (umur >= 16 / 12 && umur < 18 / 12) {
        data_umur["16 bulan"].push(a);
      } else if (umur >= 18 / 12 && umur < 2) {
        data_umur["18 bulan"].push(a);
      } else if (umur >= 2 && umur < 3) {
        data_umur["2"].push(a);
      } else if (umur >= 3 && umur < 4) {
        data_umur["3"].push(a);
      } else if (umur >= 4 && umur < 5) {
        data_umur["4"].push(a);
      } else if (umur >= 5 && umur < 6) {
        data_umur["5"].push(a);
      } else if (umur >= 6 && umur < 7) {
        data_umur["6"].push(a);
      }
    });
    return data_umur;
  };
  useEffect(() => {
    if (selected_form == 0) {
      getScreening();
    }
  }, [selected_form]);

  const jsonToArray = (jsonString) => {
    try {
      // Parse the JSON string into an array
      const array = JSON.parse(jsonString);
      return array;
    } catch (error) {
      // console.error("Invalid JSON string:", error);
      return null; // Return null or handle the error as needed
    }
  };
  const generateView = (data, id, type) => {
    let view = [];
    if (data != undefined && Array.isArray(data)) {
      // console.log(data);
      data?.map((a, k) => {
        // console.log(type);
        let ans = jsonToArray(JSON.stringify(a.answer));
        let jawab = [];
        if (data[k - 1] && a.umur == data[k - 1]?.umur) {
          // kok arrayne ra konsisten desc atau tidak
          // data ke 0 karena urutannya desc
        } else {
          // console.log(a);
          if (ans.length > 0) {
            ans.map((b) => {
              let detail = jsonToArray(b.answer);
              jawab.push(
                <div
                  style={{
                    maxWidth: "300px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {detail[0]?.statement} :
                  {b.category_result
                    ? b.category_result
                    : typeof detail[0]?.result === "object"
                    ? JSON.stringify(detail[0].result)
                    : detail[0]?.result}
                </div>
              );
            });
          } else {
            jawab.push(
              <div
                style={{
                  maxWidth: "300px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                Screening belum selesai
              </div>
            );
          }
          view.push(
            <div>
              <b>
                usia : {a.umur_string ? a.umur_string : a.umur} tgl:{" "}
                {formatDateIndo(a.created_at)}
              </b>
              <br />
              {type != "total"
                ? jawab
                : `${
                    a.result_keterangan == null ? "status" : a.result_keterangan
                  } : ${a.result_value}`}
            </div>
          );
        }
      });
    }
    return (
      <>
        {view}{" "}
        <a
          onClick={() => {
            setselected_form(id), console.log(id);
          }}
          className="btn btn-sm btn-neutral"
        >
          add
        </a>
      </>
    );
  };

  return (
    <div className="card">
      <div className="card-header">
        ILP
        <ReactToPrint
          trigger={() => (
            <button className="btn btn-sm btn-primary ml-5">Cetak</button>
          )}
          content={() => printTabel.current}
          pageStyle={{ overflow: "visible" }}
          copyStyles={false}
        />
      </div>
      {selected_form > 0 ? (
        <FormScreening
          id={selected_form}
          visit={props.detilPx}
          umur={umur}
          setId={() => setselected_form(0)}
        />
      ) : kluster == 2 ? (
        hamil ? (
          <div className="card-body" ref={printTabel}>
            <TableILPDewasa
              className="table table-responsive"
              label="SKRINING IBU HAMIL"
              headers={["Skrining", "K1", "K2", "K3", "K4", "K5", "K6"]}
              data={ref_screening}
              columnMapper={(a, key) => [
                <div
                  style={{
                    width: "300px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <div>
                    <h4>{a.screening_name}</h4>
                  </div>
                  <div>{a.keterangan}</div>
                </div>,
                generateView(a["K1"], a.id, a.resume_type),
                generateView(a["K2"], a.id, a.resume_type),
                generateView(a["K3"], a.id, a.resume_type),
                generateView(a["K4"], a.id, a.resume_type),
                generateView(a["K5"], a.id, a.resume_type),
                generateView(a["K6"], a.id, a.resume_type),
              ]}
              issearch={false}
              pagination={false}
            />
          </div>
        ) : umur < 7 ? (
          <div className="card-body">
            <TableILPDewasa
              className="table table-responsive"
              label="SKRINING KESEHATAN BAYI, BALITA, PRA Sekolah"
              headers={[
                "Skrining",
                "Baru Lahir",
                "1 bulan",
                "2 bulan",
                "6 bulan",
                "9 bulan",
                "16 bulan",
                "18 bulan",
                "2",
                "3",
                "4",
                "5",
                "6",
              ]}
              data={ref_screening}
              columnMapper={(a, key) => [
                <div>
                  <div
                    style={{
                      width: "300px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <h4>{a.screening_name}</h4>
                  </div>
                  <div>{a.keterangan}</div>
                </div>,
                generateView(a["Baru Lahir"], a.id, a.resume_type),
                generateView(a["1 bulan"], a.id, a.resume_type),
                generateView(a["2 bulan"], a.id, a.resume_type),
                generateView(a["6 bulan"], a.id, a.resume_type),
                generateView(a["9 bulan"], a.id, a.resume_type),
                generateView(a["16 bulan"], a.id, a.resume_type),
                generateView(a["18 bulan"], a.id, a.resume_type),
                generateView(a["2"], a.id, a.resume_type),
                generateView(a["3"], a.id, a.resume_type),
                generateView(a["4"], a.id, a.resume_type),
                generateView(a["5"], a.id, a.resume_type),
                generateView(a["6"], a.id, a.resume_type),
              ]}
              issearch={false}
              pagination={false}
            />
            <div style={{ display: "none" }}>
              <div ref={printTabel}>
                <TableILPDewasaPrint
                  label="SKRINING KESEHATAN BAYI, BALITA, PRA Sekolah"
                  headers={[
                    "Skrining",
                    "Baru Lahir",
                    "1 bulan",
                    "2 bulan",
                    "6 bulan",
                    "9 bulan",
                    "16 bulan",
                    "18 bulan",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                  ]}
                  data={ref_screening}
                  columnMapper={(a, key) => [
                    <div>
                      <div>
                        <h4>{a.screening_name}</h4>
                      </div>
                      <div>{a.keterangan}</div>
                    </div>,
                    generateView(a["Baru Lahir"], a.id, a.resume_type),
                    generateView(a["1 bulan"], a.id, a.resume_type),
                    generateView(a["2 bulan"], a.id, a.resume_type),
                    generateView(a["6 bulan"], a.id, a.resume_type),
                    generateView(a["9 bulan"], a.id, a.resume_type),
                    generateView(a["16 bulan"], a.id, a.resume_type),
                    generateView(a["18 bulan"], a.id, a.resume_type),
                    generateView(a["2"], a.id, a.resume_type),
                    generateView(a["3"], a.id, a.resume_type),
                    generateView(a["4"], a.id, a.resume_type),
                    generateView(a["5"], a.id, a.resume_type),
                    generateView(a["6"], a.id, a.resume_type),
                  ]}
                  issearch={false}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <TableILPDewasa
              className="table table-responsive"
              label="SKRINING KESEHATAN ANAK USIA SEKOLAH dan REMAJA"
              headers={[
                "Skrining",
                "7 tahun",
                "10 tahun",
                "12 tahun",
                "15 tahun",
              ]}
              data={ref_screening}
              columnMapper={(a, key) => [
                <div>
                  <div>
                    <h4>{a.screening_name}</h4>
                  </div>
                  <div>{a.keterangan}</div>
                </div>,
                generateView(a["7-10"], a.id, a.resume_type),
                generateView(a["10-12"], a.id, a.resume_type),
                generateView(a["12-15"], a.id, a.resume_type),
                generateView(a["15"], a.id, a.resume_type),
              ]}
              issearch={false}
              pagination={false}
            />
            <div style={{ display: "none" }}>
              <div ref={printTabel}>
                <TableILPDewasaPrint
                  className="table table-responsive"
                  label="SKRINING KESEHATAN ANAK USIA SEKOLAH dan REMAJA"
                  headers={[
                    "Skrining",
                    "7 tahun",
                    "10 tahun",
                    "12 tahun",
                    "15 tahun",
                  ]}
                  data={ref_screening}
                  columnMapper={(a, key) => [
                    <div>
                      <div>
                        <h4>{a.screening_name}</h4>
                      </div>
                      <div>{a.keterangan}</div>
                    </div>,
                    generateView(a["7-10"], a.id, a.resume_type),
                    generateView(a["10-12"], a.id, a.resume_type),
                    generateView(a["12-15"], a.id, a.resume_type),
                    generateView(a["15"], a.id, a.resume_type),
                  ]}
                  issearch={false}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        )
      ) : (
        <div>
          <TableILPDewasa
            className="table table-responsive"
            label="SKRINING KESEHATAN USIA DEWASA DAN LANJUT USIA"
            headers={[
              "Skrining",
              "18 tahun",
              "19 tahun",
              "30 tahun",
              "40 tahun",
              "45 tahun",
              "50 tahun",
              ">60 tahun",
            ]}
            data={ref_screening}
            columnMapper={(a, key) => [
              <div
                style={{
                  width: "300px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                <div>
                  <h4>{a.screening_name}</h4>
                </div>
                <div>{a.keterangan}</div>
              </div>,
              generateView(a[18], a.id, a.resume_type),
              generateView(a["19_30"], a.id, a.resume_type),
              generateView(a["30_40"], a.id, a.resume_type),
              generateView(a["40_45"], a.id, a.resume_type),
              generateView(a["45_50"], a.id, a.resume_type),
              generateView(a["50_60"], a.id, a.resume_type),
              generateView(a[60], a.id, a.resume_type),
            ]}
            issearch={false}
            pagination={false}
          />
          <div style={{ display: "none" }}>
            <div ref={printTabel}>
              <TableILPDewasaPrint
                className="table table-responsive"
                label="SKRINING KESEHATAN USIA DEWASA DAN LANJUT USIA"
                headers={[
                  "Skrining",
                  "18 tahun",
                  "19 tahun",
                  "30 tahun",
                  "40 tahun",
                  "45 tahun",
                  "50 tahun",
                  ">60 tahun",
                ]}
                data={ref_screening}
                columnMapper={(a, key) => [
                  <div
                    style={{
                      width: "300px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <div>
                      <h4>{a.screening_name}</h4>
                    </div>
                    <div>{a.keterangan}</div>
                  </div>,
                  generateView(a[18], a.id, a.resume_type),
                  generateView(a["19_30"], a.id, a.resume_type),
                  generateView(a["30_40"], a.id, a.resume_type),
                  generateView(a["40_45"], a.id, a.resume_type),
                  generateView(a["45_50"], a.id, a.resume_type),
                  generateView(a["50_60"], a.id, a.resume_type),
                  generateView(a[60], a.id, a.resume_type),
                ]}
                issearch={false}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ilp;
